import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/@shared/services/common.service';

@Component({
  selector: 'app-expose-detail',
  templateUrl: './expose-detail.component.html',
  styleUrls: ['./expose-detail.component.css']
})
export class ExposeDetailComponent implements OnInit {

  public api = api;
  public env = environment;
  public data: any;
  private subs: Subscription[] = [];
  private uId: any;
  submitted = false;

  constructor(public service: WebserviceService,
    private _common: CommonService,
    public router: Router,
    public actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.getData('');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(url: any) {
    this.data = undefined;
    let apiurl = url == '' ? `${this.env.baseUrl + this.api.pendingExpose}/${this.actRoute.snapshot.paramMap.get('uid')}` : url;
    const sub1 = this.getServices().Get(apiurl).subscribe(
      (res) => {
        if (res.status == true) {
          res.data.exposes = this._common.UTC_to_Local_timeZone(res.data.exposes);
          this.data = this.groupDataByMarketId(res);
        } else {
          this.data = {};
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  groupDataByMarketId(data: any): any[] {
    const groupedData = data.data.exposes.reduce((result: any, expose: any) => {
      const marketId = expose.market_id;
      const existingMarket = result.find((market: any) => market.market_id === marketId);

      if (existingMarket) {
        existingMarket.exposes.push(expose);
      } else {
        result.push({ market_id: marketId, exposes: [expose] });
      }

      return result;
    }, []);

    groupedData.forEach((group: any) => {
      const leastExposureEntry = group.exposes.reduce((minExposure: any, expose: any) => {
        const currentExposure = parseFloat(expose.expose);
        if (currentExposure < minExposure) {
          return expose;
        }
        return expose;
      }, Infinity);

      group.dt = leastExposureEntry;
    });

    return groupedData;
  }

  displayMarketName(e:any) {
    return (e?.market_id[0] == '9') ? e?.fancy_name : (e?.market_id[0] == '8') ? `BOOK MAKER [${e?.bookmaker_name}]` : e?.market_type_id.replace(/_/g,' '); 
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  changePage(e: any) {
    if (e.label != this.data.transactions.current_page) {
      this.getData(e.url);
    }
  }

  ngDoCheck() {
    if (this.uId != this.actRoute.snapshot.paramMap.get('uid')) {
      this.uId = this.actRoute.snapshot.paramMap.get('uid');
      this.getData('');
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
